import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=3b4ad8dd&"
import script from "./BillsTable.vue?vue&type=script&lang=js&"
export * from "./BillsTable.vue?vue&type=script&lang=js&"
import style0 from "./BillsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports